import { Link, Navigate, useParams } from "react-router-dom";
import Sidebar from "@/layouts/PostLogin/components/Sidebar/Sidebar";
import Hey from "@/components/SVGComponents/Hey";
import welcomeImage from "@/assets/png/Welcome.png";
import {
  AUTH_ROUTE_PATHS,
  JOURNEY_STEP_KEYS,
  ROLE_CONTENT,
  getJourneyPath,
  getSignUpPath,
  resolveAuthRole,
} from "@/pages/Auth/authConfig";
import { captalizeEachWord, getCurrentUser } from "@/lib/utils";
import { getSignUpJourneyDraft } from "@/pages/Auth/signUpJourney";
import styles from "./Onboarding.module.scss";

const Onboarding = () => {
  const { role: roleParam } = useParams();
  const role = resolveAuthRole(roleParam);


  if (!role) {
    return <Navigate replace to={AUTH_ROUTE_PATHS.roleSelection} />;
  }

  const signUpDraft = getSignUpJourneyDraft(role);

  if (!signUpDraft?.accountCreated) {
    return <Navigate replace to={getSignUpPath(role)} />;
  }

  const sampleProfile = ROLE_CONTENT[role].sampleData;
  const currentUser = getCurrentUser();
  const memberName = captalizeEachWord(
    currentUser?.name ||
      currentUser?.userName ||
      `${sampleProfile.firstName} ${sampleProfile.lastName}`,
  );
  const totalSteps = ROLE_CONTENT[role].signUpSteps.length;

  return (
    <section className={styles.page}>
      <div className={styles.card}>
        <Sidebar activeStep={JOURNEY_STEP_KEYS.welcome} role={role} />

        <div className={styles.contentPanel}>
          <div className={styles.inner}>
            <div className={styles.progressContainer}>
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${(3 / totalSteps) * 100}%` }}
                />
              </div>
              <span className={styles.progressText}>Step 3 of {totalSteps}</span>
            </div>

            <div className={styles.body}>
              <div className={styles.copyColumn}>
                <img className={styles.waveIcon} src="/hey.png" alt="Hey" />
                <p className={styles.eyebrow}>Hey</p>
                <h1 className={styles.title}>{memberName},</h1>
                <h2 className={styles.subtitle}>
                  Answer a few questions to see events that matter to you
                </h2>
                <p className={styles.description}>
                  We&apos;ll use this to show you events that are most relevant to
                  you.
                </p>
              </div>

              <div className={styles.illustrationWrap}>
                <img
                  alt="BFC welcome illustration"
                  className={styles.illustration}
                  src={welcomeImage}
                />
              </div>
            </div>

            <div className={styles.footerRow}>
              <div className={styles.buttonGroup}>
                <Link
                  replace
                  className={styles.primaryButton}
                  to={getJourneyPath(JOURNEY_STEP_KEYS.questions, role)}
                >
                  <span>Let&apos;s Start</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Onboarding;
